module.exports = __webpack_public_path__ + "static/img/main-bg.2cc67773.png";